/**
 * Copyright © Veeam Software Group GmbH.
 */

import { UserTitleRepresentation as UserTitleRepresentationModel } from '@veeam-vspc/models/web-controllers';

export type UserTitleRepresentation = UserTitleRepresentationModel;
export const UserTitleRepresentation = UserTitleRepresentationModel;
